import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import useGroupEdit from '@/views/modules/group/groups-edit/useGroupEdit'
import useHelpers from '@/views/modules/useHelpers'


export default function useCalendarsList(root) {

  const refCalendarListTable = ref(null)
  const { toaster } = useGroupEdit(root)
  const { confirm } = useHelpers(root)

  const tableColumns = [
    { key: 'name', sortable: false, label: 'Name'},
    { key: 'actions' },
  ]

  const perPage = ref(10)
  const totalCalendars = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const requestStatus = ref(false)

  const dataMeta = computed(() => {

    const localItemsCount = refCalendarListTable.value ? refCalendarListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalCalendars.value,
    }
  })

  const refetchData = () => {
    refCalendarListTable.value.refresh()
  }

  const filter = ref({})

  watch([currentPage, perPage, searchQuery ], () => {
    filter.value = {
      ...(searchQuery.value && {q: searchQuery.value})
    }
    refetchData()
  })


  const fetchCalendars = (ctx, callback) => {

    requestStatus.value = true
    store
      .dispatch('app-calendar/fetchCalendars', {
        length: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        ...filter.value
      })
      .then(response => {
        requestStatus.value = false
        const { data, total } = response.data
        callback(data)
        totalCalendars.value = total
      })
      .catch(e => {
        requestStatus.value = false
        console.log(e)
      })
  }


  const removeCalendar = (id) => {

    requestStatus.value = true
    store.dispatch('app-calendar/deleteCalendar', id)
      .then(_ => {
        toaster('Calendars Deleted Successfully')
        refetchData()
      })
      .catch(reason => console.log(reason))
  }



  return {

    fetchCalendars,
    tableColumns,
    perPage,
    currentPage,
    totalCalendars,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refCalendarListTable,
    removeCalendar,
    requestStatus,
    refetchData,

  }
}
